import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Wrench } from "@phosphor-icons/react";

export default function LoginPage() {
  const { login, session } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (session) nav(params.get("next") || "/", { replace: true });
  }, [session, nav, params]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      nav(params.get("next") || "/", { replace: true });
    } catch (e) {
      setErr("Invalid email or password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-12 w-12 bg-blue-600 flex items-center justify-center rounded">
            <Wrench size={28} weight="bold" className="text-white" />
          </div>
          <div>
            <h1 className="font-display text-3xl font-black text-white tracking-tight leading-none">TMIC OPS</h1>
            <p className="font-body text-sm text-slate-400">Operations & Compliance</p>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white p-6 rounded-lg border-2 border-slate-300 flex flex-col gap-4" data-testid="login-form">
          <div>
            <label className="font-body text-sm font-semibold text-slate-700">Email</label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-12 text-base border-2 mt-1" required autoComplete="username" />
          </div>
          <div>
            <label className="font-body text-sm font-semibold text-slate-700">Password</label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="h-12 text-base border-2 mt-1" required autoComplete="current-password" />
          </div>
          {err && <p data-testid="login-error" className="text-sm text-red-600 font-semibold">{err}</p>}
          <Button data-testid="login-submit" type="submit" disabled={busy}
            className="h-12 text-base font-bold uppercase tracking-wide bg-slate-900 hover:bg-slate-800">
            {busy ? "Signing in…" : "Sign In"}
          </Button>
          <a data-testid="forgot-password-link" href="/forgot-password"
            className="font-body text-sm font-semibold text-blue-600 text-center hover:underline">
            Forgot password?
          </a>
          <p className="font-body text-xs text-slate-500 text-center">Access is by administrator invitation only.</p>
        </form>
      </div>
    </div>
  );
}
